import {actions as A} from '../constants/actions';

export const setFirmLogo = firmLogo => dispatch => (
  dispatch({
    type: A.SET_FIRM_LOGO,
    payload: {firmLogo}
  })
);
